import type { Role } from "../services/user"

export const settingsPermission: Record<Role, boolean> = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Publisher: false,
  Writer: false,
  Contributor: false
}

export const bulkActionsPermission: Record<Role, boolean> = {
  SuperUser: true,
  Owner: true,
  Administrator: true,
  Publisher: true,
  Writer: false,
  Contributor: false
}
